import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Topbar from './components/Topbar/Topbar';

const PREFIX = 'Minimal';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    backgroundColor: '#f4f6f8',
    paddingTop: 64,
    ['@media (max-width:700px)']: {
      paddingTop: 56,
    },
    height: '100%',
  },

  [`& .${classes.content}`]: {
    height: '100%',
  },
}));

const Minimal = props => {
  const { children } = props;

  return (
    <Root className={classes.root}>
      <Topbar />
      <main className={classes.content}>{children}</main>
    </Root>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Minimal;
